module.exports = __webpack_public_path__ + "img/veryHappy.275423f5.png";